<template>
  <div v-if="dataLoaded">
    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor:
          milestone_banner.approval === 'Pending' ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">Banner</h5>
        <span v-if="milestone_banner.approval === 'Pending'" class="float-right btn bg-secondary">
          <i class="fa fa-lock text-white"></i>
        </span>
      </div>
      <div class="card-body">
        <div class="col-4">
          <div style="display: flex; flex-direction: column">
            <div style="display: flex; flex-direction: row; align-items: center">
              <img :src="milestone_banner.image_url || ''" style="
                  width: 120px;
                  height: 120px;
                  object-fit: contain;
                  border-radius: 10px;
                  border: dashed 1px gray;
                " />
              <div v-if="!isApprover && milestone_banner.approval !== 'Pending'"
                class="fileUpload bg-none text-left align-middle d-block">
                <div>
                  <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
                </div>
                <button @click="openGalleryModal('milestone_banner')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                  Browse...
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Debug button -->
        <div class="float-right">
          <button @click="bannerButtonPreview" class="btn btn-light m-2">
            Preview
          </button>
          <button v-if="!isApprover && milestone_banner.approval !== 'Pending'" @click="bannerButtonDraft"
            class="btn btn-light m-2">
            Save Draft
          </button>
          <button v-if="!isApprover && milestone_banner.approval !== 'Pending'" @click="bannerButtonSubmit"
            class="btn btn-warning m-2">
            Submit For Approval
          </button>
          <button v-if="isApprover && milestone_banner.approval === 'Pending'" data-bs-toggle="modal"
            data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
            @click="openApprovalModal('milestone_banner')">
            Approval
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor:
          milestone_description.approval === 'Pending' ||
            milestone_image.approval === 'pending'
            ? '#ffc107'
            : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">McDonald's Brunei Corporate Milestone</h5>
        <span v-if="milestone_description.approval === 'Pending' ||
          milestone_image.approval === 'pending'
          " class="float-right btn bg-secondary">
          <i class="fa fa-lock text-white"></i>
        </span>
      </div>
      <div class="card-body">
        <h5 class="fw-bold">Description</h5>
        <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2"
          v-model="milestone_description.description"
          :disabled="isApprover || milestone_description.approval === 'Pending'"></textarea>

        <div class="col-lg-12 row">
          <div class="col-lg-4 b-r-dark">
            <p>
              This is the image section of the Corporate Milestone page, where you
              can easily update the image.
            </p>
            <div class="mt-4 mb-3 milestone-img"></div>
          </div>
          <div class="col-lg-8">
            <div class="col-4">
              <div style="display: flex; flex-direction: column">
                <div style="display: flex; flex-direction: row; align-items: center">
                  <img :src="milestone_description.image_url || ''" style="
                      width: 120px;
                      height: 120px;
                      object-fit: contain;
                      border-radius: 10px;
                      border: dashed 1px gray;
                    " />
                  <div v-if="!isApprover && milestone_description.approval !== 'Pending'"
                    class="fileUpload bg-none text-left align-middle d-block">
                    <div>
                      <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800
                        px)</span>
                    </div>
                    <button @click="openGalleryModal('milestone_image')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                      Browse...
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="float-right">
          <button @click="milestonePreview" class="btn btn-light m-2">
            Preview
          </button>
          <button v-if="!isApprover &&
            (milestone_description.approval !== 'Pending' ||
              milestone_image.approval !== 'Pending')
            " @click="milestoneDraft" class="btn btn-light m-2">
            Save Draft
          </button>
          <button v-if="!isApprover &&
            (milestone_description.approval !== 'Pending' ||
              milestone_image.approval !== 'Pending')
            " @click="milestoneSubmit" class="btn btn-warning m-2">
            Submit For Approval
          </button>
          <button v-if="isApprover &&
            (milestone_description.approval === 'Pending' ||
              milestone_image.approval === 'Pending')
            " data-bs-toggle="modal" data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
            @click="openApprovalModal('milestone_image')">
            Approval
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div v-else class="text-center p-4">
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading milestone data...</p>
  </div>
</template>

<script>
import SmallButtonComponent from "@/components/SmallButtonComponent.vue";
import DropFile from "@/components/DropFile.vue";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import { getRequest, postRequest } from "@/services/RequestService";
import ImageComponent from "@/components/ImageComponent.vue";
import ApprovalComponent from "@/components/ApprovalComponent.vue";
import { checkUserRole } from "@/services/Auth.js";

export default {
  components: {
    SmallButtonComponent,
    DropFile,
    FileUploadComponent,
    ImageComponent,
    ApprovalComponent,
  },

  data() {
    return {
      milestone_banner: {}, // Changed from [] to {}
      milestone_description: {}, // Changed from [] to {}
      milestone_image: {}, // Changed from [] to {}
      isApprover: false,
      testing: null,
      dataLoaded: false, // Added loading state
      datas: [],
    };
  },

  methods: {
    async loadMilestone() {
      try {
        let response = await getRequest("/about-us/create?section=4", true);

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }
        
        // Safe assignment with fallbacks
        this.milestone_banner = response.data.data.milestone_banner || {};
        this.milestone_image = response.data.data.milestone_image || {};
        this.milestone_description = response.data.data.milestone_description || {};
        
        // Set loading complete
        this.dataLoaded = true;
        
        // Emit to parent component
        this.emitMilestoneData();
        
        console.log('Milestone data loaded:', {
          banner: this.milestone_banner,
          description: this.milestone_description,
          image: this.milestone_image
        });
        
      } catch (error) {
        console.error("Error fetching API data:", error);
        this.dataLoaded = true; // Show UI even on error
      }
    },

    emitMilestoneData() {
      this.$emit("milestone", {
        banner: this.milestone_banner,
        image: this.milestone_description,
      });
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";

      this.emitMilestoneData();
    },

    //Banner Section
    async bannerButtonPreview() {
      if (this.milestone_banner.approval == 'Pending' || (this.milestone_banner.approval == 'Approved' && this.isApprover)) {
        window.open("/corporate-milestone?preview=1");
      } else {
        let postData = {
          image: this.milestone_banner.gallery_id
            ? this.milestone_banner.gallery_id
            : this.milestone_banner.image_id,
          approval: false,
        };

        let response;
        if (this.milestone_banner.approval === "Draft") {
          response = await postRequest(
            "/milestones/banner/" + this.milestone_banner.id,
            postData
          );
        } else {
          response = await postRequest("/milestones/banner", postData);
        }

        if (response.data.success) {
          window.open("/corporate-milestone?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },

    bannerButtonDraft() {
      this.bannerSubmission(this.milestone_banner, 0);
    },

    bannerButtonSubmit() {
      this.bannerSubmission(this.milestone_banner, 1);
    },

    async bannerSubmission(data, approval) {
      try {
        let post_request = this._bannerRequest(data);
        post_request.approval = approval;

        let response;
        if (this.milestone_banner.approval === "Draft") {
          response = await postRequest(
            "/milestones/banner/" + this.milestone_banner.id,
            post_request
          );
        } else {
          response = await postRequest("/milestones/banner", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bannerRequest(data) {
      return {
        image: this.milestone_banner.gallery_id
          ? this.milestone_banner.gallery_id
          : this.milestone_banner.image_id,
        status: 0,
      };
    },

    //Corporate Milestone Section
    async milestonePreview() {
      if (this.milestone_description.approval == 'Pending' || (this.milestone_description.approval == 'Approved' && this.isApprover)) {
        window.open("/corporate-milestone?preview=1");
      } else {
        let postData = {
          image: this.milestone_description.gallery_id
            ? this.milestone_description.gallery_id
            : this.milestone_description.image_id,
          description: this.milestone_description.description,
          approval: false,
        };

        let response;
        if (this.milestone_description.approval === "Draft") {
          response = await postRequest(
            "/milestones/description/" + this.milestone_description.id,
            postData
          );
        } else {
          response = await postRequest("/milestones/description", postData);
        }

        if (response.data.success) {
          window.open("/corporate-milestone?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },

    milestoneDraft() {
      this.milestoneSubmission(this.milestone_description, 0);
    },

    milestoneSubmit() {
      this.milestoneSubmission(this.milestone_description, 1);
    },

    async milestoneSubmission(data, approval) {
      try {
        let post_request = this._milestoneRequest(data);
        post_request.approval = approval;

        let response;
        if (this.milestone_description.approval === "Draft") {
          response = await postRequest(
            "/milestones/description/" + this.milestone_description.id,
            post_request
          );
        } else {
          response = await postRequest("/milestones/description", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _milestoneRequest(data) {
      return {
        image: this.milestone_description.gallery_id
          ? this.milestone_description.gallery_id
          : this.milestone_description.image_id,
        description: this.milestone_description.description,
        status: 0,
      };
    },

    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },

    openApprovalModal(modalName) {
      document.getElementById("data_id").value = modalName;;

      this.$emit("milestone_approval", {
        banner: this.milestone_banner,
        description: this.milestone_description,
      });
    },
  },

  watch: {
    milestone_banner: {
      handler(newVal) {
        console.log('milestone_banner updated:', newVal);
        this.testing = newVal;
      },
      deep: true
    }
  },

  async mounted() {
    await this.checkUserRole();
    await this.loadMilestone();
  },
};
</script>

<style>
.milestone-img {
  height: 15rem;
  background-image: url("@/assets/images/admin/about-us/Corporate Milestone.svg");
  background-size: contain;
  background-position-x: center;
}
</style>